export default __webpack_public_path__ + "static/media/icon_expired.87bf9274.svg";